

















































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { Route, RouteConfig } from 'vue-router'
import { isExternal } from '@/utils/validate'
import SidebarItemLink from './SidebarItemLink.vue'
import { checkStorageAccess } from '@/utils/permission'

@Component({
  // Set 'name' here to prevent uglifyjs from causing recursive component not work
  // See https://medium.com/haiiro-io/element-component-name-with-vue-class-component-f3b435656561 for detail
  name: 'SidebarItem',
  components: {
    SidebarItemLink
  }
})
export default class extends Vue {
  @Prop({ required: true }) private item!: RouteConfig
  @Prop({ default: false }) private isCollapse!: boolean
  @Prop({ default: true }) private isFirstLevel!: boolean
  @Prop({ default: '' }) private basePath!: string

  get alwaysShowRootMenu() {
    if (this.item.meta && this.item.meta.alwaysShow) {
      return true
    }
    return false
  }

  get showingChildNumber() {
    if (this.item.children) {
      const showingChildren = this.item.children.filter((item) => {
        if (item.meta && item.meta.hidden) {
          return false
        } else {
          return true
        }
      })
      return showingChildren.length
    }
    return 0
  }

  get theOnlyOneChild() {
    if (this.showingChildNumber > 1) {
      return null
    }
    if (this.item.children) {
      for (let child of this.item.children) {
        if (!child.meta || !child.meta.hidden) {
          return child
        }
      }
    }
    // If there is no children, return null to show the item as a submenu
    return null
  }

  private resolvePath(routePath: string) {
    if (isExternal(routePath)) {
      return routePath
    }
    if (isExternal(this.basePath)) {
      return this.basePath
    }

    // Если routePath начинается с '/', это абсолютный путь
    if (routePath.startsWith('/')) {
      return routePath
    }

    // Если basePath пустой, возвращаем routePath
    if (this.basePath === '') {
      return routePath
    }

    // Если routePath пустой, возвращаем basePath
    if (routePath === '') {
      return this.basePath
    }

    // Объединяем пути, избегая двойных слешей
    return `${this.basePath}/${routePath}`.replace(/\/+/g, '/')
  }

  get checkStoragePermission() {
    return this.item.path === 'documents' && checkStorageAccess();
  }

  get hasStorageAccess() {
    if (!this.item.meta || !this.item.meta.checkStorageAccess) {
      return true; // Если не требуется проверка прав, разрешаем доступ
    }
    const UserManagerService = require('@/services/data/user_manager').default;
    const storage_access = UserManagerService.current_user?.storage_access;
    return storage_access === 'read_and_edit' || storage_access === 'read_only';
  }

  get canShowItem() {
    if (this.item.meta && this.item.meta.hidden) return false

    const isStorage = this.item.path === 'documents'
    if (!isStorage) return true
    const UserManagerService = require('@/services/data/user_manager').default;
    const access = UserManagerService.current_user.storage_access
    return access === 'read_and_edit' || access === 'read_only'
  }

}
